import {Region} from '@/store/models';
import store from '@/store';

const cache: any = {};

export function findRegions(countryCode: string): Region[] | undefined {
    const {countryData} = store.state;

    // eslint-disable-next-line no-prototype-builtins
    if (countryCode && countryData.associations.hasOwnProperty(countryCode)) {
        const associations: number[] = countryData.associations[countryCode];

        // eslint-disable-next-line no-prototype-builtins
        if (!cache.hasOwnProperty(countryCode)) {
            cache[countryCode] = countryData.regions.filter(
                (reg: Region) => associations.indexOf(reg.region_id) !== -1
            );
        }

        return cache[countryCode] as Region[];
    }

    return undefined;
}

export function findRegionById(id: number): Region {
    const {countryData} = store.state;
    return countryData.regions.find((reg) => reg.region_id === id) as Region;
}

export function findRegionByCode(code: string): Region | undefined {
    const {countryData} = store.state;
    return countryData.regions.find((reg) => reg.region_code === code) as Region;
}

export function findCountryRegionByCode(countryId: string, code: string): Region | undefined {
    const {countryData} = store.state;
    return countryData.regions.find((reg) => reg.region_code === code && reg.country_id === countryId) as Region;
}
